import { useMutation } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';
export type ResetPasswordRequest = {
  email: string;
  password: string;
  reset_key: string;
};

export type ResetPasswordResponse = {
  success: boolean;
  message: string;
};

export const sendResetPassword = async (
  credentials: ResetPasswordRequest
): Promise<ResetPasswordResponse> => {
  const response = await Axios.post<ResetPasswordResponse>(
    `${POST_URL().resetPass}`,
    credentials
  );
  return response.data;
};
export function useResetPassword() {
  return useMutation<
    ResetPasswordResponse,
    AxiosError<BaseError>,
    ResetPasswordRequest
  >((credentials: ResetPasswordRequest) => sendResetPassword(credentials), {
    useErrorBoundary: false
  });
}
